/**
* Created For: 用户登录
* Author: chenLiYan.
* Date: 2018/11/28 0028 17:56.
*/
<template>
  <div class="login-page">
    <img :class="class_logo" :src="logo" />
    <form class="form-wrap" autocomplete="off">
      <label class="item-li flex-wrap">
        <input v-model.trim="params.username" type="text" :maxlength="40" placeholder="输入账号"/>
        <span class="sprite icon-close" v-if="params.username" @click="params.username=''"></span>
      </label>
      <label class="item-li flex-wrap">
        <input v-model.trim="params.password" :type="passInputType" :maxlength="20" placeholder="输入密码"/>
        <template v-if="passInputType==='password'">
          <span @click="passInputType='text'" class="sprite icon-eye-close" v-if="params.password"></span>
        </template>
        <template v-else-if="passInputType==='text'">
          <span @click="passInputType='password'" class="sprite icon-eye-view" v-if="params.password"></span>
        </template>
      </label>
      <label class="item-li flex-wrap">
        <input v-model="params.captchaCode" style="width: 60%" auto-complete="off" placeholder="验证码">
        <div class="login-code" >
          <img :src="codeUrl" @click="getCode" class="login-code-img" />
        </div>
      </label>
      <button type="button" :class="['submit-btn',isValid ? 'valid' :'']" @click="loginHandle">登录</button>
    </form>
    <span class="forget-psd" @click="forgetPwd">忘记密码</span>
    <div :class="['powered',isKeyboard ? 'keyboard':'']">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">Copyright © 2021 未名企鹅（北京）科技有限公司出品<br/>备案号：京ICP备12021457号</a>
    </div>
    <custom-loading v-if="loading"></custom-loading>
  </div>
</template>

<script>
import CustomLoading from '@/components/CustomLoading.vue'
import { getCodeImg } from '@/api/auth'
const winHeight = document.documentElement.clientHeight // 默认屏幕高度
export default {
  name: 'Login',
  components: {
    CustomLoading
  },
  props: {},
  data () {
    return {
      codeUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAnCAYAAAC2c+5GAAAAZ0lEQVRoge3QMRHAMBDAsCT8YT6PZutgAu0gIfB5z8yzeJ2vA/7GkDAkDAlDwpAwJAwJQ8KQMCQMCUPCkDAkDAlDwpAwJAwJQ8KQMCQMCUPCkDAkDAlDwpAwJAwJQ8KQMCQMCUPCkLgMcgP5gqyNnwAAAABJRU5ErkJggg==',
      class_logo: 'logo',
      logo: require('../../assets/logo.png'),
      loading: false,
      isKeyboard: false, // 是否键盘被调起
      params: {
        username: this.$store.state.user.localUserName,
        password: '',
        captchaCode: '',
        uuid: ''
      },
      passInputType: 'password' // 密码隐藏与显示切换
    }
  },
  computed: {
    isValid () {
      return !!(this.params.username && this.params.password)
    }
  },
  created () {
    this.getCode()
  },
  mounted () {
    if (this.$store.state.UserAgent === 'android') {
      // window.onresize监听页面高度的变化
      window.onresize = () => {
        return (() => {
          this.isKeyboard = winHeight > document.body.clientHeight
        })()
      }
    }
    var url = window.location.href
    if (url.includes('mbayer')) {
      this.logo = require('@/assets/logo-bayer.png')
      this.class_logo = 'class_logo_big'
    } else if (url.includes('mhanyao')) {
      this.logo = require('@/assets/logo-hdzy.png')
      this.class_logo = 'class_logo_big'
    } else if (url.includes('mlbs.yiyao')) {
      this.logo = require('@/assets/logo-yabao.png')
      this.class_logo = 'class_logo_big'
    } else {
      this.logo = require('@/assets/logo.png')
      //    this.class_logo = 'class_logo_big'
    }
  },
  methods: {
    getCode () {
      getCodeImg().then(res => {
        this.codeUrl = 'data:image/gif;base64,' + res.data.img
        this.params.uuid = res.data.uuid
      })
    },
    // 登录点击事件
    loginHandle () {
      let message = ''
      if (!this.params.username) {
        message = '请输入账号'
      } else if (!this.params.password) {
        message = '请输入密码'
      } else if (!this.params.captchaCode) {
        message = '请输入验证码'
      }
      if (message) {
        window.scrollTo(0, 0)
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: message
        }).show()
      } else if (!this.loading) {
        this.loading = true
        window.scrollTo(0, 0)
        // 触发登录
        this.$store.dispatch('Login', this.params).then(res => {
          this.loading = false
          if (res.code === 1) {
            // 百度统计事件追踪
            this.$store.dispatch('PushHmtTrackEvent', {
              category: '用户登录',
              action: '点击',
              optLabel: this.params.username
            })
            // 上报操作日志
            // this.$store.dispatch('PushUserLog', {
            //     menu: '登录页面',
            //     page: '登录页面',
            //     operation: '登录'
            // })
            // 已经激活,跳转到首页
            if (res.data.isUserActivated) {
              this.$router.push({ name: 'index' })
            } else {
              // 未激活跳转到首次登录激活页
              this.$router.push({ name: 'resetPassword', query: { activated: true, username: this.params.username, password: this.params.password } })
            }
          }
          this.getCode()
        }).catch(() => {
          this.getCode()
          this.loading = false
        })
      }
    },
    // 忘记密码点击事件
    forgetPwd () {
      window.scrollTo(0, 0)
      this.$createDialog({
        title: '提示',
        type: 'alert',
        content: '请联系管理员修改'
      }).show()
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/sign/login.styl"
</style>
